import { PageHeader } from '@frontendmentorio/design-system-v2';

import Layout from 'features/shared/Layout';
import ArticlesIndex from 'features/articles/Index';

export default function Index({ data }) {
  return (
    <Layout
      description="Articles on front-end web development, including HTML, CSS, JavaScript, accessibility, careers, Frontend Mentor news, and more."
      image="https://res.cloudinary.com/dz209s6jk/image/upload/v1585172856/Meta/meta-homepage.png"
      title="Frontend Mentor | Articles for the Frontend Mentor community"
      url="https://www.frontendmentor.io/articles"
    >
      <PageHeader heading="Articles" />
      <ArticlesIndex data={data} />
    </Layout>
  );
}

export async function getStaticProps() {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_REST_API_URL}/v3/articles?filter=platform|learning`
  );
  const body = await res.json();

  return { props: { data: body }, revalidate: 60 * 60 * 24 };
}
